/**
 *  分模块翻译，方便维护
 *  lang/en-US/module/login.js
 */

export default {
  "login": {
    "log_in": "Log in",
    "register": "Sign up",
    "mobile_log_in": "Mobile Login",
    "psd_log_in": "Password Login",
    "wx_log_in": "WeChat Login",
    "sms_log_in": "SMS Login",
    "phone_number": "Phone#",
    "verification_code": "Verification code",
    "get_verification_code": "Get verification code",
    "account": "Mobile/Email/Username",
    "visitor": "Visitor",
    "email": "Email",
    "user_name": "Username",
    "password": "Password",
    "logging_in": "Logging in",
    "remember_me": "Remember Me",
    "forget_password": "Forgot Password",
    "social_account_login": "Social account login",
    "register_now": "Register Now",
    "link": "Link",
    "link_account": "Link Account",
    "intermediate_page": "Login to the Intermediate Page",
  }
};